/**
 * overlay module.
 * @module overlay
 */

import pubSub from './pubSub';

const className = 'overlay';
const hasActiveOverlayClass = 'has-active-overlay';
const pageHeader = document.querySelector('.page-header');
const overlayNode = document.createElement('div');

// set class and add data-attribute
overlayNode.classList.add(className);
overlayNode.dataset.overlay = true;

// add overlay to DOM
document.body.appendChild(overlayNode);

// group overlay functions
const overlay = {
  show: () => {
    const intScrollTop = document.body.scrollTop || document.documentElement.scrollTop;

    // add class
    document.body.classList.add(hasActiveOverlayClass);

    // set body position
    document.body.style.transform = `translateY(-${intScrollTop}px) translateZ(0)`;

    // set header position
    pageHeader.style.transform = `translateY(${intScrollTop}px) translateZ(0)`;
    pageHeader.style.transition = 'none';
  },
  hide: () => {
    // remove class
    document.body.classList.remove(hasActiveOverlayClass);

    // reset body styles
    document.body.style.transform = '';

    // set header styles
    pageHeader.style.transform = '';
    pageHeader.style.transition = '';
  },
};

// hide on click
document.querySelector('[data-overlay]').addEventListener('click', () => {
  pubSub.publish('close.modules');
});

export default overlay;



// WEBPACK FOOTER //
// ./assets/js/components/overlay.js